import { Card } from "@/components/ui/card";
import { useEffect, useRef, useState } from "react";
import AccordionComponent from "../AccordionComponent";

export default function HowItWorks() {
  const services = [
    {
      question: "01. Submit your Video",
      answer:
        "We make the clip submission process simple. All you need to do is head to sendyourclip.com - submit the video - and we’ll respond if we need any additional details.",
    },
    {
      question: "02. We securely clear the rights",
      answer:
        "Our comprehensive licensing process ensures that all licensed videos are from the real content owners. KYC is what we do best.",
    },
    {
      question: "03. To the moon…",
      answer:
        "Once your clip has been cleared for rights, we’ll add our rocket fuel and work our magic to promote the video and maximize its views.",
    },
  ];

  const creators = [
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/justin.mp4",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/penguin.mp4",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/apt-dance.mp4",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/prank.mp4",
    "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/vvv/seal.mp4",
  ];

  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div
      id="how-it-works"
      className="px-6 py-24 lg:px-12 lg:py-12 4xl:max-w-[100rem] 4xl:mx-auto xxx-40"
    >
      <div className="flex flex-col lg:flex-row justify-between items-center text-white gap-10">
        <div className="lg:w-1/2 space-y-14">
          <div className="space-y-2 text-center lg:text-left">
            <p className="text-white/70">Stand out from the crowd</p>
            <h1 className="uppercase text-4xl md:text-5xl vvv-font">
              How It Works
            </h1>
          </div>
          <div className="w-full flex flex-col items-stretch">
            {services.map((faq, idx) => (
              <AccordionComponent
                key={idx}
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === idx}
                onClick={() => handleToggle(idx)}
                containerHeight="lg:h-[113px] xl:h-[104px] 1xl:h-[130px]"
              />
            ))}
          </div>
        </div>

        <div className="w-full lg:w-1/2 flex items-stretch justify-center gap-4 relative overflow-hidden">
          {[1, 2, 3].map((dup) => (
            <section
              key={dup}
              className="scroll-section-left pb-1 gap-4"
              style={{ "--speed": "30000ms" }}
            >
              {creators.map((creator, index) => (
                <div key={index} className="flex-shrink-0 w-48">
                  <CreatorCard src={creator} />
                </div>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

function CreatorCard({ src }) {
  const ref = useRef(null);
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = entry.isIntersecting;
        setIsVisible(visible);
        if (visible && !hasLoaded) setHasLoaded(true);
      },
      { threshold: 0.6 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [hasLoaded]);

  useEffect(() => {
    if (!videoRef.current) return;
    if (isVisible) videoRef.current.play().catch(() => {});
    else videoRef.current.pause();
  }, [isVisible]);

  return (
    <Card
      ref={ref}
      className="relative overflow-hidden border-0 p-0 rounded-xl"
    >
      {hasLoaded ? (
        <video
          loading="lazy"
          ref={videoRef}
          src={src}
          muted
          loop
          playsInline
          preload={isVisible ? "auto" : "metadata"}
          className="w-full h-[400px] lg:h-[500px] object-cover rounded-[70px]"
        />
      ) : (
        <div className="bg-gray-200 w-full h-[400px] lg:h-[500px] rounded-[70px]" />
      )}
    </Card>
  );
}
